import { useState } from 'react';
import type { MerchantSpending } from '../../entities/summary/index.js';
import { formatBaseMoney } from '../../features/summary-view/index.js';
import { List, ListItem } from '../../shared/ui/index.js';

const VISIBLE_MERCHANTS = 10;

type BankLegend = {
  marker: string | undefined;
  share: string | undefined;
  amountMinor: number;
};

type CategoryMerchantsProps = {
  merchants: MerchantSpending[];
  bank: BankLegend;
  currency: string;
  onOpen: (merchantKey: string) => void;
};

export const CategoryMerchants = ({
  merchants,
  bank,
  currency,
  onOpen,
}: CategoryMerchantsProps) => {
  const [isExpanded, setExpanded] = useState(false);
  const shownMerchants = isExpanded ? merchants : merchants.slice(0, VISIBLE_MERCHANTS);
  const hiddenCount = merchants.length - shownMerchants.length;

  return (
    <List header="По продавцях">
      <ListItem
        title="Операції з картки"
        marker={bank.marker}
        subtitle={bank.share}
        value={formatBaseMoney(bank.amountMinor, currency)}
      />
      {shownMerchants.map((merchant) => (
        <ListItem
          key={merchant.merchantKey}
          title={merchant.name}
          subtitle={`Операцій: ${String(merchant.operationCount)}`}
          value={formatBaseMoney(merchant.spentMinor, currency)}
          chevron
          onClick={() => {
            onOpen(merchant.merchantKey);
          }}
        />
      ))}
      {hiddenCount > 0 && (
        <ListItem
          title={`Показати всіх продавців: ${String(merchants.length)}`}
          onClick={() => {
            setExpanded(true);
          }}
        />
      )}
    </List>
  );
};
